import type { ApiRoute, NoBody, NoPathParams, NoQueryParams } from "../../api"
import type { CustomInteriorOptionsView } from "../../common/colors/interiorColor/CustomInteriorOptionsView"

export const getCustomInteriorOptionsRoute: ApiRoute<NoPathParams, NoQueryParams, NoBody, CustomInteriorOptionsView> = {
	buildUrl: () => "/colors/interior/custom-options",
	method: "get",
	path: "/colors/interior/custom-options",
}
